import { render, staticRenderFns } from "./purchaseQuantityTooLowReminder.vue?vue&type=template&id=70cce475&scoped=true&"
import script from "./purchaseQuantityTooLowReminder.vue?vue&type=script&lang=js&"
export * from "./purchaseQuantityTooLowReminder.vue?vue&type=script&lang=js&"
import style0 from "./purchaseQuantityTooLowReminder.vue?vue&type=style&index=0&id=70cce475&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cce475",
  null
  
)

export default component.exports